import axiosDocumentIns from '@/services/axios/axiosDocumentos'
import axiosSecurity from '../axios/axiosSecurity'

export default class DocumentoService {
  static async getAgendamentoMensagensAnexos(agendamentoId) {
    return axiosDocumentIns.get(`agendamentos/${agendamentoId}/anexos`).then(res => res.data.data)
  }

  static async getFormularioComponentAnexos(ticketId, componenteId) {
    return axiosDocumentIns.get(`tickets/${ticketId}/elementos/${componenteId}/anexos`).then(res => res.data.data)
  }

  static async getTicketMensagensAnexos(ticketId) {
    return axiosDocumentIns.get(`tickets/${ticketId}/mensagens/anexos`).then(res => res.data.data)
  }

  static async getFotoPerfil(id) {
    if (!id) return null
    try {
      const fotoId = await this.getFotoPerfilUsuarioId(id)
      return await axiosDocumentIns.get(`fotos-perfis/${fotoId}`).then(res => res.data.data?.url)
    } catch {
      return null
    }
  }

  static async getFotoPerfilUsuarioId(id) {
    if (!id) return null
    try {
      return await axiosSecurity.get(`colaboradores/${id}`).then(res => res.data.data.fotoId)
    } catch {
      return null
    }
  }

  static async getAnexosTicketMensagem(ticketId) {
    return axiosDocumentIns.get(`tickets/${ticketId}/mensagens/anexos`).then(res => res.data.data)
  }
}
